import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React from 'react'
import ReactDom from 'react-dom'
import { Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import {
  positions,
  transitions,
  Provider as AlertProvider,
} from 'react-alert'
import ReactGA from 'react-ga4'
// eslint-disable-next-line
import { createBrowserHistory } from 'history'
import './i18n'
import moment from 'moment-timezone'

import { URL } from './view/constants/url'

import { setupStore } from './states/containers/store'

import * as Sentry from '@sentry/browser'
import App from './view/App'
import Alert from './view/components/common/Alert'

import fontawesome from '@fortawesome/fontawesome'
import faSolid from '@fortawesome/fontawesome-free-solid'
import faRegular from '@fortawesome/fontawesome-free-regular'
import faBrands from '@fortawesome/fontawesome-free-brands'
import { IconDefinition, IconPack, library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

import './view/assets/scss/base/reset.css'
import './view/assets/scss/base/frame.scss'
import './vendor/js/exresize'

import { isManager, isMember } from './utils/role'
import 'ie11-custom-properties'

moment.tz.setDefault("Asia/Tokyo")

const store = setupStore()
export default store

const rootElem = document.querySelector('#root')

if (rootElem) {
  // MEMO: Pitschedular用のAwesomefont設定
  fontawesome.library.add(faSolid, faRegular, faBrands)
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  fontawesome.dom.i2svg({ node: rootElem, callback: () => { } })
}
// React用のAwesomefont設定
library.add(fab as IconDefinition | IconPack)
library.add(fas as IconDefinition | IconPack)
library.add(far as IconDefinition | IconPack)

const alertOptions = {
  offset: "0px",
  timeout: 3000,
  position: positions.TOP_CENTER,
  containerStyle: {
    zIndex: 9999,
  },
}

const history = createBrowserHistory()
const isMasterLogin = store.getState().login?.isMasterLogin

if (!isMasterLogin) {
  ReactGA.initialize('G-DDSMX9NP96')
}

if (process.env.NODE_ENV === 'production') {
  history.listen((location) => {
    if (!isMasterLogin) {
      const current_member_id = store.getState().login?.current_member_id
      const company_id = store.getState().login?.company_id
      const roles = store.getState().login?.role
      let role
      if (isMember(roles)) {
        role = 'member'
      } else if (isManager(roles)) {
        role = 'manager'
      }

      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
        userId: current_member_id,
        company_id: company_id,
        role: role,
        member_id: current_member_id,
      })
    }
  })
  Sentry.init({ dsn: "https://7016e12c61404a12974cb8a95161008e@o403300.ingest.sentry.io/5265724" })
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const OneSignal = window.OneSignal || []
OneSignal.push(() => {
  OneSignal.init({
    appId: process.env.ONESIGNAL_APPID,
    allowLocalhostAsSecureOrigin: true,
    safari_id: process.env.ONESIGNAL_SAFARI_ID,
    autoResubrscribe: true,
    notifyButton: {
      enable: false,
    },
    welcomeNotification: {
      disable: true,
    },
  })
})

ReactDom.render(
  <Provider store={store}>
    <AlertProvider
      template={Alert}
      {...alertOptions}
    >
      <Router history={history}>
        <App />
      </Router>
    </AlertProvider>
  </Provider>,
  rootElem,
)
